import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  Box,
  List,
  ListItem,
  ListItemText,
  Checkbox
} from '@mui/material';
import { Obra } from '../../types';

interface ObraMultiSelectorProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (selectedObras: string[]) => void;
  obras: Obra[];
  obrasSeleccionadas: string[];
  titulo: string;
}

export const ObraMultiSelector: React.FC<ObraMultiSelectorProps> = ({
  open,
  onClose,
  onConfirm,
  obras,
  obrasSeleccionadas,
  titulo
}) => {
  const [selected, setSelected] = React.useState<string[]>(obrasSeleccionadas || []);

  const handleToggle = (id: string) => {
    const currentIndex = selected.indexOf(id);
    const newChecked = [...selected];

    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelected(newChecked);
  };

  const handleConfirm = () => {
    onConfirm(selected);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{titulo}</DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
          <FormControl component="fieldset" fullWidth>
            <List>
              {obras.map((obra) => (
                <ListItem
                  key={obra.id}
                  dense
                  onClick={() => handleToggle(obra.id)}
                  sx={{ cursor: 'pointer' }}
                >
                  <Checkbox
                    edge="start"
                    checked={selected.indexOf(obra.id) !== -1}
                    tabIndex={-1}
                    disableRipple
                  />
                  <ListItemText
                    primary={obra.nombre}
                    secondary={`${obra.ubicacion} - ${obra.estado}`}
                  />
                </ListItem>
              ))}
            </List>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};